import { render } from "./InstanceCard.vue?vue&type=template&id=6656fa1b&scoped=true"
import script from "./InstanceCard.vue?vue&type=script&lang=js"
export * from "./InstanceCard.vue?vue&type=script&lang=js"

import "./InstanceCard.vue?vue&type=style&index=0&id=6656fa1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6656fa1b"]])

export default __exports__